import { Country } from '@afterpaytouch/portal-api/types'
import { useCountry, useGetCreditCheckConsent } from '../../state'

/**
 * Whether this consumer's durable US FEB consumer-report authorization is already on file, so
 * payment-type surfaces may drop their inline authorization line (CASHDAP-4064).
 *
 * `started.creditCheckConsent` is the /start-time bureau read of the V4 grant captured at
 * login/sign-up (CASHDAP-3450/3922); the backend populates it only while
 * `paylater.enable-checkout-evergreen-consent` is on. Keyed off the grant rather than the flag
 * so sessions that never saw the login/sign-up copy (persistent-login resumes, pre/post-login
 * LD context mismatches, bureau write failures) keep the inline line — a PCL application must
 * never render with no consumer-report authorization displayed at all.
 */
export const useHasDurableFebConsent = (): boolean => {
  const country = useCountry()
  const creditCheckConsent = useGetCreditCheckConsent()
  return country === Country.US && creditCheckConsent === true
}
